import { ApplicationItemLayout } from '../layouts'

export const ActiveProductSelector = (state, props) => {
  return {
    product: state.data.loan
  }
}

export const OpenApplicationListSelector = (state, props) => {
  return{
    customer_applications: state.data.customer_applications.filter(app => app.status === 'open')
  }
}

export const ClosedApplicationListSelector = (state, props) => {
  return{
    customer_applications: state.data.customer_applications.filter(app => app.status === 'closed')
  }
}

export const AvantApplicationListSelector = (state, props) => {
  return {
    customer_applications: state.data.customer_applications
  }
}

export const ApplicationListItemProductSelector = (state, props) => {
  const app = state.data.customer_applications.find(app => app.id === props.id)
  return {
    icon: '#icon-product',
    title: 'Product',
    value: app && app.product_type
  }
}

export const ApplicationListItemAmountSelector = (state, props) => {
  const app     = state.data.customer_applications.find(app => app.id === props.id) || {}
  const product = state.data.loans.find(loan => loan.application_id === app.id)
  const value = product ? product.amount_pretty : null
  return {
    icon: '#icon-amount',
    title: 'Amount',
    value: value
  }
}

export const ApplicationListItemNextStepSelector = (state, props) => {
  const app = state.data.customer_applications.find(app => app.id === props.id)
  const next_steps_key = app.product_type === 'credit_card' ? 'credit_card_next_steps' : 'next_steps'
  return {
    icon: '#icon-next',
    title: 'Next Step',
    value: props.t(`customer_applications.${next_steps_key}.${app.stage}`)
  }
}

export const ApplicationClosedAtSelector = (state, props) => {
  const app = state.data.customer_applications.find(app => app.id === props.id)
  return {
    icon: '#icon-date',
    title: 'Closed At',
    value: app.closed_at_pretty
  }
}

export const ApplicationOwnerSelector = (state, props) => {
  return{
    icon: '#icon-issuer',
    title: 'Issuer',
    value: state.data.customer_applications.find(app => app.id === props.id).application_owner_pretty
  }
}

export const ApplicationItemSelector = (state, props) => {
  return {
    application_status: state.data.customer_applications.find(app => app.id === props.id).status
  }
}

export const CustomerFirstNameSelector = (state, props) => {
  return{
    first_name: state.data && state.data.customer && state.data.customer.first_name
  }
}

export const ProductsSelector = (state, props) => {
  return{
    products: state.data.loans.concat(state.data.credit_card_accounts).filter(product => !['applied', 'rejected', 'cancelled', 'approved'].includes(product.status))
  }
}

export const ProductSelector = (state, props) => {
  // @todo support many product types in this decision
  const collection = props.product_type === 'credit_card' ? state.data.credit_card_accounts : state.data.loans
  return{
    product: collection.find(p => p.id === props.id)
  }
}

export const ActionablePaymentSelector = (state, props) => {
  return{
    payment: state.data.actionable_payments.find(p => props.id)
  }
}

export const ApplicationStageSelector = (state, props) => {
  const app = state.data.customer_applications.find(a => a.id === props.id)
  return{
    stage: app && app.stage
  }
}

export const ApplicationInReviewSelector = (state, props) => {
  const app = state.data.customer_applications.find(a => a.id === props.id)
  return{
    in_review: app && app.in_review
  }
}

export const BankAccountSelector = (state, props) => {
  return {
    bank_account: state.data.bank_account
  }
}

export const CustomerSelector = (state, props) => {
  return{
    customer: state.data.customer
  }
}

export const CustomerCanApplyNewLoanSelector = (state, props) => {
  const { notices = []} = state.data
  return{
    notice: notices.find(notice => notice.notice_type === 'customer_can_apply_new_loan')
  }
}

export const CustomerCreditLineDashboardSelector = (state, props) => {
  const { notices = []} = state.data
  return{
    notice: notices.find(notice => notice.notice_type === 'customer_can_view_credit_line_dashboard')
  }
}

export const FSRWorkflowSelector = (state, props) => {
  return{
    notice: state.data.workflow_notices.find(({ action: {name, type} = {}}) => type === 'workflow' && name === 'financial_situation_review')
  }
}

export const NoticesSelector = (state, props) => {
  return{
    notices: state.data.workflow_notices
  }
}

export const LocaleSelector = (state, props) => {
  return{
    locale: state.data.config.locale
  }
}
